import axios from "axios";
import API from "../helpers/api";
import FileSaver from "file-saver";
import {
  getEquipmentZoneList,

} from "../Actions/EquipmentManagementAPI";

let currentUser = JSON.parse(localStorage.getItem("currentUser"));



export const postAnnualCertificate = (postItem, key) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.DynamicAttachment}?id=` + key;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "annualAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "annualAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};
export const postBiannualCertificate = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "biannualAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "biannualAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};
export const postFiveYearlyCertificate = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "fiveyearlyAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "fiveyearlyAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};
export const postTenYearlyCertificate = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "tenyearlyAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "tenyearlyAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const deleteAttachmentInBucket = (deleteItem) => { 
  
  const url = `${API.AttachmentDelete}`;  
 
  return (dispatch) => {
          axios({
            method : "DELETE",
            url : url,
            data : deleteItem,
          })
          .then((response) => {               
          })
          .catch((error) => {              
          });
  };
};


export const postFlagAttachment = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "postFlagAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postFlagAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};


export const postClassAttachment = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "postClassAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postClassAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const postMiscAttachment = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "postMiscAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postMiscAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const postModalAttachment = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "postModalAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postModalAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const postFirePlanAttachment = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.FirePlanAttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "postFirePlanAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postFirePlanAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};
export const postShipContractAttachment = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.FirePlanAttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "postShipContractAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postShipContractAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};
export const getServiceTypeList = () => {
  let url = `${API.GetServiceTypeList}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        let list = [];
        let serviceTypeList = []
        response.data.map((item, index) => {
          let listItem = item.serviceTypes.split(" ");
          let order = (listItem[0])
          list.push(order);
        })
        let mainList = list.sort(function (a, b) {
          return a - b;
        })
        mainList.map((item, i) => {
          item = item + " yearly";
          serviceTypeList.push(item);
        })
        dispatch({
          type: "getIntervalServiceTypeListSuccess",
          data: serviceTypeList,
        });
        
      })
      .catch((error) => {
        dispatch({
          type: "getIntervalServiceTypeListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getEquipmentServiceTypeList = (equipmentId) => {
  let url = `${API.GetEquipmentServiceTypeList}?ShipEquipmentId=${equipmentId}&mail=${currentUser.email}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({ type: "EditEquipmentDetails", data: false });
        dispatch({
          type: "getEquipmentServiceTypeListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getEquipmentServiceTypeListFailure",
          error: "ERROR",
        });
      });
  };
};

export const postContractAttachment = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "postContractAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postContractAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const uploadAttachments = (postItem, key) => {
  const data = new FormData();
  postItem.forEach((file) => {
    data.append("file", file);
  });
  // data.append('file', postItem)

  let url = `${API.DynamicAttachments}?id=` + key;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "serviceAttachmentUploadSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "annualAttachmentUploadFailure",
          error: "ERROR",
        });
      });
  };
};

export const DownloadAttachmentServiceImages = (id) => {
  let url = API.DownloadAttachmentServiceImages + id;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        var mime = require('mime-types'),
        fileExtension = mime.extension(response.data.type)
        FileSaver.saveAs(blob, response.data?.name+"."+fileExtension ?? "");
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};
